import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AccountView, BuildingProductTypeView } from '@api-proxies';
import { AccountService } from '@http/clients/account.service';
import { EditorComponentBase, GenericDropdownMultiselectComponent } from 'ngx-lib';

@Component({
    selector: 'app-account-building-product-types-editor',
    templateUrl: './account-building-product-types-editor.component.html',
    styleUrls: ['./account-building-product-types-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownMultiselectComponent]
})
export class AccountBuildingProductTypesEditorComponent
    extends EditorComponentBase<AccountView | null>
    implements OnInit
{
    selectedProductTypesItems?: BuildingProductTypeView[];
    constructor(private readonly accountService: AccountService) {
        super();
    }

    async ngOnInit(): Promise<void> {
        if (this.additionalInfo.accountId) {
            this.selectedProductTypesItems = await this.accountService.getBuildingProductTypes(
                this.additionalInfo.accountId
            );
        }
    }
}
